export default {
  monthLastDay: function (m = false, y = false) {
    return new Date(y, m, 0)
  },
  monthArrDays: function (m = false, y = false) {
    const now = new Date()
    const prevLastDay = this.monthLastDay(m, y)
    const pN = prevLastDay.getDate()
    const pS = prevLastDay.getDay()
    const currLastDay = this.monthLastDay(m + 1, y)
    const cN = currLastDay.getDate()
    const swm = []
    m = this.formatMonth(prevLastDay.getMonth())
    y = prevLastDay.getFullYear()
    let s = 0
    for (let i = pN - pS; i <= pN; i++) {
      swm.push({'d': i, 'm': m, 'y': y, 's': s++, 'yyyymmdd': y + '' + m + '' + (i > 9 ? '' : '0') + i, status: 'out'})
      if (s > 6) s = 0
    }
    const nowMonth = this.formatMonth(now.getMonth())
    m = this.formatMonth(m)
    y = currLastDay.getFullYear()
    for (let i = 1; i <= cN; i++) {
      const status = (m !== nowMonth) ? '' : (y !== now.getFullYear()) ? '' : (i !== now.getDate()) ? '' : 'now'
      swm.push({'d': i, 'm': m, 'y': y, 's': s++, 'yyyymmdd': y + '' + m + '' + (i > 9 ? '' : '0') + i, 'status': status})
      if (s > 6) s = 0
    }
    const sufixDaysCount = 42 - swm.length
    m = this.formatMonth(currLastDay.getMonth(m) + 1)
    if (m === '01') y += 1
    for (let i = 1; i <= sufixDaysCount; i++) {
      swm.push({'d': i, 'm': m, 'y': y, 's': s++, 'yyyymmdd': y + '' + m + '' + (i > 9 ? '' : '0') + i, status: 'out'})
      if (s > 6) s = 0
    }
    return swm
  },
  monthSixWeek: function (m = false, y = false) {
    const month = this.monthArrDays(m, y)
    let sixweek = []
    for (let i = 0; i < 6; i++) {
      sixweek[i] = month.slice(i * 7, i * 7 + 7)
    }
    return sixweek
  },
  formatMonth: function (m) {
    m = parseInt(m) + 1
    return m > 12 ? '01' : m > 9 ? m : '0' + m
  },
  validMonth: function (m = false) {
    if (!m || m < 0 || m > 11) return new Date().getMonth()
    return m
  },
  formatDate: function (oDate) {
    let dataa = new Date(oDate)
    return dataa.toISOString().slice(0, 10).replace(/-/g, '')
  },
  getThisWeek: function () {
    const now = new Date()
    const sunday = now.setDate(now.getDate() - now.getDay())
    const saturday = now.setDate(now.getDate() + 6)
    console.log(this.formatDate(sunday) + ' ... ' + this.formatDate(saturday))
  }
}



// WEBPACK FOOTER //
// ./src/components/JSCalendar.js